<kl-grid
  [columns]="[
    { header: 'code' | translate, binding: 'code', width: '*', visible: true },
    {
      header: 'description' | translate,
      binding: 'description',
      width: '*',
      visible: true
    },
    {
      header: 'document_type' | translate,
      binding: 'document_type',
      width: '*',
      translate: true,
      visible: true
    }
  ]"
  [filterable]="true"
  [deferResizing]="false"
  [tabId]="tabId || modalId"
  [filterSelectItems]="filterSelectItems"
  [service]="{
    service: 'numberscheme',
    name: 'number_schema',
    form: 'NUMBERSCHEME',
    showButton: true,
    showDropDownButton: true
  }"
  [parentModuleName]="'APPLICATION_PARAMS'"
  [moduleName]="'NUMBER_SCHEMA_LIST'"
  [gridName]="'grdNumberSchemaList'"
>
</kl-grid>
